module.exports = __webpack_public_path__ + "media/images/icons/zoom-in-1bcd60338c93f605bce863bf4c64368d.svg";